export default __webpack_public_path__ + "static/media/box-tick-azure.dbc49450.svg";